module.exports = __webpack_public_path__ + "img/dc3aec5.png";